import { Component, Input } from '@angular/core';
import { ContactType } from '../../models/contacts';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-contact-type',
  imports: [MatIcon],
  standalone: true,
  templateUrl: './contact-type.component.html',
  styleUrl: './contact-type.component.scss'
})
export class ContactTypeComponent {
  @Input() type: ContactType = 'Person';
}
